import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-gray-lightShow" }
const _hoisted_2 = { class: "relative" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "absolute z-10 bg-gradient-to-b bottom-0 from-transparent to-black w-full h-1/2 opacity-70" }, null, -1)
const _hoisted_5 = { class: "absolute bottom-0 z-20 text-left space-y-2 px-4 py-8" }
const _hoisted_6 = { class: "text-xl text-white font-bold" }
const _hoisted_7 = { class: "text-base text-white" }
const _hoisted_8 = { class: "p-4 text-left" }
const _hoisted_9 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _ctx.campaign.imageUrl,
        alt: "",
        class: "aspect-square object-cover"
      }, null, 8, _hoisted_3),
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.campaign.title), 1),
        _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.campaign.description), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("p", {
        innerHTML: _ctx.getRichHtmlText(_ctx.campaign.body)
      }, null, 8, _hoisted_9)
    ])
  ]))
}